import { render } from "./TodasVisitasForm.vue?vue&type=template&id=46b9e03b"
import script from "./TodasVisitasForm.vue?vue&type=script&lang=js"
export * from "./TodasVisitasForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__